import { render, staticRenderFns } from "./CopyLinkButton.vue?vue&type=template&id=1ea96996"
import script from "./CopyLinkButton.vue?vue&type=script&lang=js"
export * from "./CopyLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports